/** Части на пустоту не проверяются: у каждого вызывающего свой ответ на «части нет» (null, undefined, бросок). */
export function storageFileUrl(endpoint: string, bucket: string, path: string): string {
  return `${endpoint}/${bucket}/${path}`;
}
